type AuditDomainChipProps = {
  auditUrl: string;
};

export default function AuditDomainChip({ auditUrl }: AuditDomainChipProps) {
  const hostname = hostnameFromAuditUrl(auditUrl);

  return (
    <div className="rounded-xl border border-primary/15 bg-primary/5 px-4 py-3.5 text-left">
      <p className="text-xs font-semibold tracking-wide text-primary uppercase text-center">Website</p>
      <p className="mt-1 break-all font-mono text-sm font-medium text-gray-900 text-center">{hostname}</p>
    </div>
  );
}

function hostnameFromAuditUrl(auditUrl: string) {
  try {
    const withProtocol = /^https?:\/\//i.test(auditUrl) ? auditUrl : `https://${auditUrl}`;
    return new URL(withProtocol).hostname;
  } catch {
    return auditUrl.replace(/^https?:\/\//i, "").replace(/\/.*$/, "");
  }
}
